module.exports = __webpack_public_path__ + "img/history2.e1ef0405.png";